<template>
	<div>
		<canvas ref="chart" :style="{'height': height + 'px'}"></canvas>
	</div>
</template>

<script>
	import { Chart, registerables } from 'chart.js';
	Chart.register(...registerables);

	// 主题柱状色：与客户端 dashboard 图表一致的品牌蓝纯色，配白底卡片
	const BAR_COLOR = '#1890ff';
	const GRID_COLOR = 'rgba(0, 0, 0, .06)';
	const TICK_COLOR = '#8c8c8c';

	export default ({
		props: [
			'data',
			'height',
		],
		data(){
			return {
				chart: null,
			} ;
		},
		watch: {
			// 数据由父组件异步填充（API 返回后才有柱子），需在变化时重建图表，
			// 否则只会停留在 mounted 时的空数据（0~1 空网格、无柱子）
			data: {
				handler(newData) {
					if (this.chart) {
						this.chart.data = this.normalize(newData);
						this.chart.options.scales.y.ticks.suggestedMax = this.computeSuggestedMax(newData);
						this.chart.update();
					} else {
						this.$nextTick(() => this.createChart());
					}
				},
				deep: true,
			},
		},
		methods: {
			createChart() {
				if (!this.$refs.chart) return;
				let ctx = this.$refs.chart.getContext("2d");
				if (this.chart) this.chart.destroy();
				this.chart = new Chart(ctx, {
					type: "bar",
					data: this.normalize(this.data),
					options: this.buildOptions(),
				});
			},
			buildOptions() {
				return {
					layout: {
						padding: { top: 30, right: 15, left: 10, bottom: 5 },
					},
					responsive: true,
					maintainAspectRatio: false,
					plugins: {
						legend: { display: false },
					},
					tooltips: {
						enabled: true,
						mode: "index",
						intersect: false,
					},
					scales: {
						y: {
							grid: {
								display: true,
								color: GRID_COLOR,
								borderDash: [6],
								borderDashOffset: [6],
							},
							ticks: {
								suggestedMin: 0,
								suggestedMax: this.computeSuggestedMax(this.data),
								display: true,
								color: TICK_COLOR,
								font: { size: 14, lineHeight: 1.5, weight: '600', family: "Open Sans" },
							},
						},
						x: {
							grid: { display: false },
							ticks: {
								display: true,
								color: TICK_COLOR,
								font: { size: 14, lineHeight: 1.5, weight: '600', family: "Open Sans" },
							},
						},
					},
				};
			},
			// 统一柱子配色为品牌蓝纯色，避免依赖画布渐变底
			normalize(src) {
				const base = src || { labels: [], datasets: [] };
				const datasets = (base.datasets || []).map(d => ({
					...d,
					backgroundColor: BAR_COLOR,
					borderColor: BAR_COLOR,
				}));
				return { labels: base.labels || [], datasets };
			},
			// 依据真实量级自适应 Y 轴上限（如 956 → 1148），不固定 1000
			computeSuggestedMax(src) {
				const ds = (src && src.datasets) || [];
				let max = 0;
				ds.forEach(d => {
					(Array.isArray(d.data) ? d.data : []).forEach(v => {
						const n = Number(v);
						if (!isNaN(n) && n > max) max = n;
					});
				});
				if (max <= 0) return 1000;
				return Math.ceil((max * 1.2) / 100) * 100;
			},
		},
		mounted () {
			this.$nextTick(() => this.createChart());
		},
		// Right before the component is destroyed,
		// also destroy the chart.
		beforeDestroy: function () {
			if (this.chart) this.chart.destroy() ;
		},
	})

</script>

<style lang="scss" scoped>
	canvas {
		// 柱子由品牌蓝纯色填充，画布改浅灰白底，去除突兀蓝紫渐变
		background-color: #fafbfc;
	}
</style>